// loader
export const LOADER_ACTIVATE = 'LOADER_ACTIVATE';
export const LOADER_DEACTIVATE = 'LOADER_DEACTIVATE';
export const EVENT_FORM_COVER_IMAGE_LOADER_ACTIVATE = 'EVENT_FORM_COVER_IMAGE_LOADER_ACTIVATE ';
export const EVENT_FORM_COVER_IMAGE_LOADER_DEACTIVATE = 'EVENT_FORM_COVER_IMAGE_LOADER_DEACTIVATE ';

// user
export const ACCEPT_POLICY = 'ACCEPT_POLICY';
export const DISABLE_PROFILE_TUTORIAL_STEPS = 'DISABLE_PROFILE_TUTORIAL_STEPS';
export const USER_UPDATE_AVATAR = 'USER_UPDATE_AVATAR';
export const USER_THIRD_PARTY_INFO = 'USER_THIRD_PARTY_INFO';
export const USER_CANCEL_SOCIAL_LOGIN = 'USER_CANCEL_SOCIAL_LOGIN';
export const USER_THIRD_PARTY_INFO_CLEAN = 'USER_THIRD_PARTY_INFO_CLEAN';
export const USER_SIGNUP_ROLE = 'USER_SIGNUP_ROLE';
export const USER_LINKEDIN_STATE = 'USER_LINKEDIN_STATE';
export const USER_GITHUB_STATE = 'USER_GITHUB_STATE';
export const USER_GITHUB_ID = 'USER_GITHUB_ID';
export const USER_SIGNUP = 'USER_SIGNUP';
export const ACCOUNT_REGISTER = 'ACCOUNT_REGISTER';
export const USER_LOGIN = 'USER_LOGIN';
export const HACKHUB_ACCOUNT_LOGIN = 'HACKHUB_ACCOUNT_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_UPDATE_TOKEN = 'USER_UPDATE_TOKEN';
export const USER_FETCH_INFO = 'USER_FETCH_INFO';
export const USER_FETCH_GITHUB_REPOS = 'USER_FETCH_GITHUB_REPOS';
export const USER_RESET_GITHUB_REPOS = 'USER_RESET_GITHUB_REPOS';
export const USER_UPDATE_PROFILE = 'USER_UPDATE_PROFILE';
export const USER_UPDATE_SOCIAL_MEDIA = 'USER_UPDATE_SOCIAL_MEDIA';
export const USER_UPDATE_PERMISSION = 'USER_UPDATE_PERMISSION';
export const UPDATE_LAST_VIEWED_ESSENTIAL_PAGE =
  'UPDATE_LAST_VIEWED_ESSENTIAL_PAGE';
export const RESET_LAST_VIEWED_ESSENTIAL_PAGE =
  'RESET_LAST_VIEWED_ESSENTIAL_PAGE';
export const SET_USER_CURRENT_TEAM = 'SET_USER_CURRENT_TEAM';
export const SET_USER_SELECTED_TEAM = 'SET_USER_SELECTED_TEAM';
export const SET_USER_PHONE_VERIFIED = 'SET_USER_PHONE_VERIFIED';
export const SET_USER_EMAIL_VERIFIED = 'SET_USER_EMAIL_VERIFIED';
export const SET_USER_RESUME_ANALYSIS = 'SET_USER_RESUME_ANALYSIS';
export const ENABLE_INTERCOM = 'ENABLE_INTERCOM';
export const DISABLE_INTERCOM = 'DISABLE_INTERCOM';
export const IN_TEAM = 'IN_TEAM';
export const FETCH_USER_TICKETS_LIST = 'FETCH_USER_TICKETS_LIST';
export const USER_EVENTAPPLIED = 'USER_EVENTAPPLIED';

// company
export const FETCH_USER_COMPANY = 'FETCH_USER_COMPANY';

// projects
export const PROJECT_FETCH_ALL = 'PROJECT_FETCH_ALL';
export const PROJECT_RESET_SINGLE_FOR_SUBMISSION_CARD =
  'PROJECT_RESET_SINGLE_FOR_SUBMISSION_CARD';
export const PROJECT_FETCH_SINGLE_FOR_SUBMISSION_CARD =
  'PROJECT_FETCH_SINGLE_FOR_SUBMISSION_CARD';
export const PROJECT_FETCH_SINGLE = 'PROJECT_FETCH_SINGLE';
export const PROJECT_UPDATE_SINGLE = 'PROJECT_UPDATE_SINGLE';
export const PROJECT_RESET_SINGLE = 'PROJECT_RESET_SINGLE';
export const PROJECT_SWTICH_VIEW = 'PROJECT_SWTICH_VIEW';
export const POST_PROJECT_BRIEF = 'POST_PROJECT_BRIEF';
export const PROJECT_UDPATE = 'PROJECT_UDPATE';
export const LEAVE_PROJECT = 'LEAVE_PROJECT';
export const APPLY_PROJECT = 'APPLY_PROJECT';

// tags
export const FETCH_TAGS = 'FETCH_TAGS';
export const ADD_TAG = 'ADD_TAG';

// chat
export const SET_CHAT_USER = 'SET_CHAT_USER';

// steps
export const SET_STEPS = 'SET_STEPS';
export const VIEWED_DASHBOARD = 'VIEWED_DASHBOARD';
export const VIEWED_PROFILE = 'VIEWED_PROFILE';
export const RESET_INTRO = 'RESET_INTRO';

// Events
export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_SINGLE_EVENT = 'FETCH_SINGLE_EVENT';
export const RESET_EVENTS = 'RESET_EVENTS';
export const SUBMIT_EVENT = 'SUBMIT_EVENT';
export const JOIN_EVENT = 'JOIN_EVENT';
export const FETCH_INITIAL_EVENTS = 'FETCH_INITIAL_EVENTS';
export const RESET_INITIAL_EVENTS = 'RESET_INITIAL_EVENTS';
export const FETCH_EVENT_LISTS = 'FETCH_EVENT_LISTS';
export const FETCH_MORE_EVENT_LISTS = 'FETCH_MORE_EVENT_LISTS';
export const RESET_EVENT_LISTS = 'RESET_EVENT_LISTS';


// Event
export const FETCH_EVENT_DETAIL = 'FETCH_EVENT_DETAIL';
export const FETCH_EVENT_TEAMS = 'FETCH_EVENT_TEAMS';
export const FETCH_SINGLE_EVENT_TEAM = 'FETCH_SINGLE_EVENT_TEAM';
export const FETCH_USER_TEAM = 'FETCH_USER_TEAM';
export const FETCH_TEAM_GROUPS = 'FETCH_TEAM_GROUPS';
export const FETCH_TEAM_SUBMISSION = 'FETCH_TEAM_SUBMISSION';
export const FETCH_EVENT_SUBMISSIONS = 'FETCH_EVENT_SUBMISSIONS';

// Teams
export const FETCH_TEAM_LIST = 'FETCH_TEAM_LIST';
export const CREATE_TEAM = 'CREATE_TEAM';
export const DELETE_TEAM = 'DELETE_TEAM';
export const UPDATE_TEAM = 'UPDATE_TEAM';
export const UPDATE_TEAM_MATCHING_PERCENT = 'UPDATE_TEAM_MATCHING_PERCENT';

// Event Comments
export const FETCH_EVENT_COMMENTS = 'FETCH_EVENT_COMMENTS';
export const CREATE_EVENT_COMMENT = 'CREATE_EVENT_COMMENT';
export const REPLY_EVENT_COMMENT = 'REPLY_EVENT_COMMENT';

// View
export const RESET_VIEW = 'RESET_VIEW';
export const SET_EVENT_DETAIL_TEAMS_CONTENT_VIEW =
  'SET_EVENT_DETAIL_TEAMS_CONTENT_VIEW';
export const SET_SORT_METHOD = 'SET_SORT_METHOD';
export const SET_FILTER_VAL = 'SET_FILTER_VAL';
export const SET_EVENT_TEAM_SIDEBAR_TAB = 'SET_EVENT_TEAM_SIDEBAR_TAB';
export const UPDATE_EVENT_USER_INFO = 'UPDATE_EVENT_USER_INFO';
export const SET_EVENT_TEMPORARILY_ACCESSIBLE = 'SET_EVENT_TEMPORARILY_ACCESSIBLE';

// CMS Event
export const FETCH_CMS_EVENT = 'FETCH_CMS_EVENT';
export const FETCH_CMS_EVENT_DETAIL = 'FETCH_CMS_EVENT_DETAIL';
export const CREATE_CMS_EVENT = 'CREATE_CMS_EVENT';
export const UPDATE_CMS_EVENT = 'UPDATE_CMS_EVENT';
export const REMOVE_CMS_EVENT = 'REMOVE_CMS_EVENT';
export const FETCH_CMS_EVENT_RANKING = 'FETCH_CMS_EVENT_RANKING';
export const FETCH_CMS_EVENT_RANKING_BY_MULTI_ROUND = 'FETCH_CMS_EVENT_RANKING_BY_MULTI_ROUND';
export const RESET_RANKING_SCORES = 'RESET_RANKING_SCORES';
export const SET_EVENT_SUBMISSION_VISIBILITY = 'SET_EVENT_SUBMISSION_VISIBILITY';
export const SET_ALL_EVENTS_SUBMISSION_VISIBILITY = 'SET_ALL_EVENTS_SUBMISSION_VISIBILITY';
export const SET_COMMENTS_VISIBILITY = 'SET_COMMENTS_VISIBILITY';
export const IMPORT_PARTICIPANT_CSV = 'IMPORT_PARTICIPANT_CSV';
export const FETCH_CMS_EVENT_INVOICES = 'FETCH_CMS_EVENT_INVOICES';

// CMS Event Info
export const CMS_EVENT_PARTICIPANT_CHECKINNUM = 'CMS_EVENT_PARTICIPANT_CHECKINNUM';
export const CMS_EVENT_PARTICIPANT_CHECKINNUM_UPDATE = 'CMS_EVENT_PARTICIPANT_CHECKINNUM_UPDATE';
export const CMS_EVENT_INTRODUCTION_PLAY = 'CMS_EVENT_INTRODUCTION_PLAY';
export const CMS_CLOSE_INTRODUCTION_VIDEO = 'CMS_CLOSE_INTRODUCTION_VIDEO';

// CMS Event Manger
export const FETCH_CMS_EVENT_MANAGER = 'FETCH_CMS_EVENT_MANAGER';
export const ADD_CMS_EVENT_MANAGER = 'ADD_CMS_EVENT_MANAGER';
export const REMOVE_CMS_EVENT_MANAGER = 'REMOVE_CMS_EVENT_MANAGER';

// CMS Event Judge
export const FETCH_CMS_EVENT_JUDGE = 'FETCH_CMS_EVENT_JUDGE';
export const ADD_CMS_EVENT_JUDGE = 'ADD_CMS_EVENT_JUDGE';
export const REMOVE_CMS_EVENT_JUDGE = 'REMOVE_CMS_EVENT_JUDGE';

// CMS Event Multi-round Judge
export const FETCH_CMS_EVENT_MULTI_ROUND_JUDGE = 'FETCH_CMS_EVENT_MULTI_ROUND_JUDGE';
export const ADD_CMS_EVENT_MULTI_ROUND_JUDGE = 'ADD_CMS_EVENT_MULTI_ROUND_JUDGE';
export const REMOVE_CMS_EVENT_MULTI_ROUND_JUDGE = 'REMOVE_CMS_EVENT_MULTI_ROUND_JUDGE';

// CMS Event Mentor
export const FETCH_CMS_EVENT_MENTOR = 'FETCH_CMS_EVENT_MENTOR';
export const ADD_CMS_EVENT_MENTOR = 'ADD_CMS_EVENT_MENTOR';
export const REMOVE_CMS_EVENT_MENTOR = 'REMOVE_CMS_EVENT_MENTOR';
export const CHANGE_MENTOR_ADMISSION_STATUS = 'CHANGE_MENTOR_ADMISSION_STATUS';

// CMS Event Volunteer
export const FETCH_CMS_EVENT_VOLUNTEER = 'FETCH_CMS_EVENT_VOLUNTEER';
export const ADD_CMS_EVENT_VOLUNTEER = 'ADD_CMS_EVENT_VOLUNTEER';
export const REMOVE_CMS_EVENT_VOLUNTEER = 'REMOVE_CMS_EVENT_VOLUNTEER';
export const CHANGE_VOLUNTEER_ADMISSION_STATUS = 'CHANGE_VOLUNTEER_ADMISSION_STATUS';

// CMS Event Participant
export const FETCH_CMS_EVENT_PARTICIPANT = 'FETCH_CMS_EVENT_PARTICIPANT';
export const ADD_CMS_EVENT_PARTICIPANT = 'ADD_CMS_EVENT_PARTICIPANT';
export const REMOVE_CMS_EVENT_PARTICIPANT = 'REMOVE_CMS_EVENT_PARTICIPANT';
export const APPEND_PARTICIPANTS = 'APPEND_PARTICIPANTS';
export const CHECK_IN_PARTICIPANT = 'CHECK_IN_PARTICIPANT';
export const CHANGE_PARTICIPANT_ADMISSION_STATUS = 'CHANGE_PARTICIPANT_ADMISSION_STATUS';
export const ACCEPT_CMS_EVENT_CANDIDATE = 'ACCEPT_CMS_EVENT_CANDIDATE';
export const REJECT_CMS_EVENT_CANDIDATE = 'REJECT_CMS_EVENT_CANDIDATE';

// CMS Event Judging Criteria
export const FETCH_CMS_EVENT_JUDGING_CRITERIA = 'FETCH_CMS_EVENT_JUDGING_CRITERIA';
export const CREATE_CMS_EVENT_JUDGING_CRITERIA = 'CREATE_CMS_EVENT_JUDGING_CRITERIA';
export const REMOVE_CMS_EVENT_JUDGING_CRITERIA = 'REMOVE_CMS_EVENT_JUDGING_CRITERIA';
export const UPDATE_CMS_EVENT_JUDGING_CRITERIA = 'UPDATE_CMS_EVENT_JUDGING_CRITERIA';
export const REORDER_CMS_EVENT_JUDGING_CRITERIA = 'REORDER_CMS_EVENT_JUDGING_CRITERIA';
export const CHANGE_JUDGE_ADMISSION_STATUS = 'CHANGE_JUDGE_ADMISSION_STATUS';
export const CHANGE_MULTI_ROUND_JUDGE_ADMISSION_STATUS = 'CHANGE_MULTI_ROUND_JUDGE_ADMISSION_STATUS';

// CMS Event Award
export const FETCH_CMS_EVENT_AWARD = 'FETCH_CMS_EVENT_AWARD';
export const CREATE_CMS_EVENT_AWARD = 'CREATE_CMS_EVENT_AWARD';
export const REMOVE_CMS_EVENT_AWARD = 'REMOVE_CMS_EVENT_AWARD';
export const UPDATE_CMS_EVENT_AWARD = 'UPDATE_CMS_EVENT_AWARD';
export const GIVE_CMS_EVENT_AWARD = 'GIVE_CMS_EVENT_AWARD';
export const CANCEL_CMS_EVENT_AWARD = 'CANCEL_CMS_EVENT_AWARD';
export const REORDER_CMS_EVENT_AWARD = 'REORDER_CMS_EVENT_AWARD';

// CMS Event Topic
export const FETCH_CMS_EVENT_TOPIC = 'FETCH_CMS_EVENT_TOPIC';
export const CREATE_CMS_EVENT_TOPIC = 'CREATE_CMS_EVENT_TOPIC';
export const REMOVE_CMS_EVENT_TOPIC = 'REMOVE_CMS_EVENT_TOPIC';
export const UPDATE_CMS_EVENT_TOPIC = 'UPDATE_CMS_EVENT_TOPIC';
export const REORDER_CMS_EVENT_TOPIC = 'REORDER_CMS_EVENT_TOPIC';

// CMS Event Screening
export const FETCH_CMS_EVENT_SCREENING = 'FETCH_CMS_EVENT_SCREENING';

// CMS Event ApplicationForm
export const FETCH_CMS_EVENT_APPLICATIONFORM = 'FETCH_CMS_EVENT_APPLICATIONFORM';

// CMS Event Ranking Awards
export const FETCH_CMS_EVENT_RANKING_AWARDS = 'FETCH_CMS_EVENT_RANKING_AWARDS';

// CMS Event Ticket
export const FETCH_CMS_EVENT_TICKET = 'FETCH_CMS_EVENT_TICKET';
export const CREATE_CMS_EVENT_TICKET = 'CREATE_CMS_EVENT_TICKET';
export const REMOVE_CMS_EVENT_TICKET = 'REMOVE_CMS_EVENT_TICKET';
export const UPDATE_CMS_EVENT_TICKET = 'UPDATE_CMS_EVENT_TICKET';
export const REORDER_CMS_EVENT_TICKET = 'REORDER_CMS_EVENT_TICKET';

// CMS Event Announcement
export const RETRIEVE_CMS_EVENT_ANNOUNCEMENT = 'RETRIEVE_CMS_EVENT_ANNOUNCEMENT';
export const CREATE_CMS_EVENT_ANNOUNCEMENT = 'CREATE_CMS_EVENT_ANNOUNCEMENT';
export const UPDATE_CMS_EVENT_ANNOUNCEMENT = 'UPDATE_CMS_EVENT_ANNOUNCEMENT';
export const DELETE_CMS_EVENT_ANNOUNCEMENT = 'DELETE_CMS_EVENT_ANNOUNCEMENT';

// CMS Uploads List
export const FETCH_UPLOADS_LIST = 'FETCH_UPLOADS_LIST';
export const DELETE_UPLOADS_LIST_ITEM = 'DELETE_UPLOADS_LIST_ITEM';

// Stripe
export const REFUND_STRIPE_TICKET = 'REFUND_STRIPE_TICKET';
export const FETCH_STRIPE_CARDS = 'FETCH_STRIPE_CARDS';
export const CREATE_STRIPE_CARD = 'CREATE_STRIPE_CARD';
export const REMOVE_STRIPE_CARD = 'REMOVE_STRIPE_CARD';
export const CHARGE_STRIPE_CARD = 'CHARGE_STRIPE_CARD';

// Notifications
export const RETRIEVE_NOTIFICATIONS = 'RETRIEVE_NOTIFICATIONS';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const DELETE_ALL_NOTIFICATION = 'DELETE_ALL_NOTIFICATION';
export const RECEIVE_NEW_NOTIFICATION = 'RECEIVE_NEW_NOTIFICATION';
export const EMAIL_VERIFICATION_SUCCESS = 'EMAIL_VERIFICATION_SUCCESS';

export const XINSHI_USER_SIGNUP = 'XINSHI_USER_SIGNUP';

// chat
export const USER_CHAT_LOGIN = 'USER_CHAT_LOGIN';
export const USER_GET_CHATDETAIL = 'USER_GET_CHATDETAIL';
export const CLOSE_CURRENT_CHAT_WINDOW = 'CLOSE_CURRENT_CHAT_WINDOW';
export const RESET_REDUCER_GROUP = 'RESET_REDUCER_GROUP';
export const ENTER_CHAT_ROOM = 'ENTER_CHAT_ROOM';
export const CREATE_NEW_CHATROOM = 'CREATE_NEW_CHATROOM';
export const ADD_NEW_CHAT = 'ADD_NEW_CHAT';
export const RECEIVE_NEW_MESSAGE = 'RECEIVE_NEW_MESSAGE';
export const ENTER_GROUPCHAT_ROOM = 'ENTER_GROUPCHAT_ROOM';
export const CREATE_NEW_GROUPCHATROOM = 'CREATE_NEW_GROUPCHATROOM';
export const CLOSE_CURRENT_GROUPCHAT_WINDOW = 'CLOSE_CURRENT_GROUPCHAT_WINDOW';
export const UPDATE_TO_FULL_HISTORY = 'UPDATE_TO_FULL_HISTORY';
export const TO_NORMAL_SCROLL = 'TO_NORMAL_SCROLL';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const DISABLE_MESSAGE = 'DISABLE_MESSAGE';
export const OPEN_MOBILE_CHATWINDOW = 'OPEN_MOBILE_CHATWINDOW';
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const SOCKET_INIT = 'SOCKET_INIT';
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const SET_LC_STATUS = 'SET_LC_STATUS';
export const SEND_LC_MESSAGE = 'SEND_LC_MESSAGE';
export const RECEIVE_NEW_LCMESSAGE = 'RECEIVE_NEW_LCMESSAGE';

// socialMedia
export const SOCIAL_INS_LOGIN = 'SOCIAL_INS_LOGIN';
export const SOCAILMEDIA_SET_EVENTSLUG = 'SOCAILMEDIA_SET_EVENTSLUG';
export const AUTH_SOCIALMEDIA_STATUS = 'AUTH_SOCIALMEDIA_STATUS';
export const UNAUTH_SOCIALMEDIA_STATUS = 'UNAUTH_SOCIALMEDIA_STATUS';
export const SOCAILMEDIA_RESET = 'SOCAILMEDIA_RESET';

// talent
export const FETCH_PUBLIC_POSTINGS = 'FETCH_PUBLIC_POSTINGS';



// WEBPACK FOOTER //
// ./src/components/actions/types.js